module.exports = __webpack_public_path__ + "img/transh-del.f8a42575.svg";